import { connect } from 'react-redux'

import SimilarPhotos from './similarPhotos'

import { decorateSearchResult } from '../../../../common/selectors/searchResults'

const mapStateToProps = (state, ownProps) => {
  const {
    searchPage: { similarItems }
  } = state
  const {
    layout: { selectedItem }
  } = state

  const itemsLoaded =
    similarItems[selectedItem.id] && !similarItems[selectedItem.id].error

  let items = itemsLoaded
    ? [selectedItem, ...similarItems[selectedItem.id].matches]
    : [selectedItem]

  return { items: items.map(i => decorateSearchResult(state, i)) }
}

const SimilarPhotosContainer = connect(mapStateToProps, null)(SimilarPhotos)

export default SimilarPhotosContainer
